var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeFundoBranco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#780000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-307.648 -317.441)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.648,317.441a12,12,0,1,0,12,12A12,12,0,0,0,319.648,317.441Zm0,23.192a11.192,11.192,0,1,1,11.193-11.192A11.193,11.193,0,0,1,319.648,340.633Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.728 319.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M321.491,335.605l4.586-3.024-4.586-3.024Z",
    transform: "translate(-313.39 -322.866)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.649,319.52a9.921,9.921,0,1,0,9.92,9.921A9.921,9.921,0,0,0,319.649,319.52Zm5.957,12.31a1.781,1.781,0,0,1-1.781,1.782h-8.354a1.781,1.781,0,0,1-1.781-1.782v-4.777a1.781,1.781,0,0,1,1.781-1.782h8.354a1.781,1.781,0,0,1,1.781,1.782Z",
    transform: "translate(-309.728 -319.52)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFundoBranco);
export default __webpack_public_path__ + "static/media/youtube_fundo_branco.c4ba5a54accd49d308ff0a63c57ea5b3.svg";
export { ForwardRef as ReactComponent };